module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-jsx/style.js
// module id = ./node_modules/styled-jsx/style.js
// module chunks = 6 9 11